import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1881c3d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 1 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" prev ")
const _hoisted_4 = { class: "pagniation__item__current" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" next ")

import BaseButton from '@/components/UI/BaseButton.vue';
import { useStore } from 'vuex';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const displayNav = computed(
  () =>
    `${store.state.charactersModule.currentPage}/${store.state.charactersModule.totalPages}`
);

const displayTotalPages = computed(
  () => store.state.charactersModule.totalPages
);

const displayPrev = computed(
  () =>
    store.state.charactersModule.currentPage > 1 &&
    !store.state.charactersModule.isLoading
);

const displayNext = computed(
  () =>
    store.state.charactersModule.currentPage <
      store.state.charactersModule.totalPages &&
    !store.state.charactersModule.isLoading
);

function handlePagination(action: string) {
  switch (action) {
    case 'first':
      if (store.state.charactersModule.currentPage !== 1) {
        store.commit('setFilters', {
          ...store.state.charactersModule.filters,
          page: 1,
        });
        store.commit('setCurrentPage', 1);
        store.dispatch('fetchCharacters');
      }
      break;
    case 'prev':
      if (store.state.charactersModule.currentPage !== 1) {
        store.commit('setFilters', {
          ...store.state.charactersModule.filters,
          page: store.state.charactersModule.prevPage,
        });
        store.commit(
          'setCurrentPage',
          store.state.charactersModule.currentPage - 1
        );
        store.dispatch('fetchCharacters');
      }
      break;
    case 'next':
      if (
        store.state.charactersModule.currentPage <
        store.state.charactersModule.totalPages
      ) {
        store.commit('setFilters', {
          ...store.state.charactersModule.filters,
          page: store.state.charactersModule.nextPage,
        });
        store.commit(
          'setCurrentPage',
          store.state.charactersModule.currentPage + 1
        );
        store.dispatch('fetchCharacters');
      }
      break;
    case 'last':
      if (
        store.state.charactersModule.currentPage <
        store.state.charactersModule.totalPages
      ) {
        store.commit('setFilters', {
          ...store.state.charactersModule.filters,
          page: store.state.charactersModule.totalPages,
        });
        store.commit('setCurrentPage', store.state.charactersModule.totalPages);
        store.dispatch('fetchCharacters');
      }
      break;
    default:
      throw new Error(`The action doesn't exist: ${action} `);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseButton, {
      disabled: !_unref(displayPrev),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (handlePagination('first'))),
      class: "pagniation__item"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(BaseButton, {
      disabled: !_unref(displayPrev),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (handlePagination('prev'))),
      class: "pagniation__item"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(displayNav)), 1),
    _createVNode(BaseButton, {
      disabled: !_unref(displayNext),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (handlePagination('next'))),
      class: "pagniation__item"
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(BaseButton, {
      disabled: !_unref(displayNext),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (handlePagination('last'))),
      class: "pagniation__item"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(displayTotalPages)), 1)
      ]),
      _: 1
    }, 8, ["disabled"])
  ]))
}
}

})